import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { getItemByRef } from 'chameleon/packages/blue-book-player/utils';
import useGetPlayerEl from 'chameleon/packages/blue-book-player/hooks/useGetPlayerEl';
import SharedPassageText from 'chameleon/packages/blue-book-player/library/SharedPassageInjector/SharedPassageText';
import { SELECTORS } from 'chameleon/packages/blue-book-player/constants/selectors';
import { setCustomClasses } from 'chameleon/packages/blue-book-player/library/SharedPassageInjector/utils';

const SharedPassageInjector = (props) => {
  const playerEl = useGetPlayerEl();
  const [sharedPassagesContainers, setSharedPassagesContainers] = useState([]);
  const { questionIndexStart, questionIndexEnd, questionsReferences } = props;

  useEffect(() => {
    const foundSharedPassagesContainers = questionsReferences.reduce(
      (result, questionRef) => {
        const questionContainer = getItemByRef(playerEl, questionRef);
        const sharedPassageContainer = questionContainer?.querySelector(
          SELECTORS.SHARED_PASSAGE_CONTAINER,
        );
        if (sharedPassageContainer) {
          setCustomClasses(sharedPassageContainer);
          result.push(sharedPassageContainer);
        }

        return result;
      },
      [],
    );

    setSharedPassagesContainers(foundSharedPassagesContainers);
  }, [questionsReferences, playerEl]);

  return sharedPassagesContainers.map((sharedPassageContainer) =>
    ReactDOM.createPortal(
      <SharedPassageText
        key={sharedPassageContainer?.id}
        startNumber={questionIndexStart + 1}
        endNumber={questionIndexEnd + 1}
        questionsLength={questionsReferences.length}
      />,
      sharedPassageContainer,
    ),
  );
};

SharedPassageInjector.propTypes = {
  questionIndexStart: PropTypes.number.isRequired,
  questionIndexEnd: PropTypes.number.isRequired,
  questionsReferences: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default SharedPassageInjector;
